import { render, staticRenderFns } from "./Follow.vue?vue&type=template&id=1c4bbd64&"
import script from "./Follow.vue?vue&type=script&lang=js&"
export * from "./Follow.vue?vue&type=script&lang=js&"
import style0 from "./Follow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports